<template>
    <div class="qr-download">
        <vue-qrious :value="hostUrl"  :size="size" level="L"/>
        <span>掃碼下載 App</span>
    </div>
</template>
<script>
import VueQrious from 'vue-qrious'

export default {
    data () {
        return {
            size: 124,
            hostUrl: window.location.href + '?device=1',
        }
    },
    components: {
        'vue-qrious': VueQrious,
    }
}
</script>
<style lang="scss"  >
    .qr-download{
        position: absolute;
        z-index: 99;
        width: 160px;
        height: 198px;
        border: solid 1px #eeeeee;
        background-color: #ffffff;
        border-radius: 4px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        padding: 10px;
        >img{
            width: 124px;
            height: 124px;
            padding: 18px;
        }
        >span{
            display: block;
            line-height: 2;
            color: #676362;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/QrDownload.vue